import React from "react"
import { Play } from "phosphor-react"

const BAR_HEIGHTS = [
  8, 8, 8, 18, 24, 24, 14, 22, 20, 18, 12, 10, 18, 14, 20, 23, 21, 8, 8, 8, 20, 20, 23, 21, 8, 8, 8,
]

export const MessageAttachmentAudio: React.FC = () => {
  return (
    <div className="flex w-full items-center justify-between gap-6 rounded-md bg-neutral-200 p-4">
      <div className="flex h-6 items-center gap-1 overflow-hidden">
        {BAR_HEIGHTS.map((h, i) => (
          <div key={i} className="w-2 rounded-full bg-base-black" style={{ height: `${h}px` }} />
        ))}
      </div>
      <div
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-base-black"
        aria-label="Play audio"
      >
        <Play size={20} weight="fill" className="text-base-white" />
      </div>
    </div>
  )
}
